import HttpProvider from "../providers/HttpProvider";

export default class DebugApi {
    private static readonly apiUrl = "/api/debug";

    public static async DoSystemLatencyTest(): Promise<void> {
        const uriStr = `${this.apiUrl}/latency-test`;

        await HttpProvider.PostRequest(uriStr, {
            startTime: new Date().toISOString()
        });
    }
}
